// Copyright (c) 2017 Deere & Company

import PipProduct from '@deere/cps-it.warranty-model-factory/lib/pip-product';
import t from 'tcomb';

const PipProducts = t.list(PipProduct, 'PipProducts');

export const getDefaultState = () => new PipProducts([]);

export default PipProducts;



// WEBPACK FOOTER //
// ./src/pip/shared/state/pip-products.js